import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { isValidUKPostcode } from "@/lib/validation";

const PROPERTY_TYPES = [
  "Terraced House",
  "Semi-Detached",
  "Detached House",
  "Flat / Apartment",
  "Bungalow",
  "Garage / Shed",
  "Garden Clearance",
  "Commercial / Office",
];

export default function Step2AddressHouse({ data, update }) {
  const postcodeTouched = data.postcode.length > 0;
  const postcodeInvalid = postcodeTouched && !isValidUKPostcode(data.postcode);

  return (
    <div className="space-y-6" data-testid="step-2-address">
      <div>
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Address & property</h2>
        <p className="mt-2 text-slate-600">
          Tell us where the clearance is so we can plan the right van and crew.
        </p>
      </div>

      <div className="grid gap-5">
        <div>
          <Label htmlFor="street" className="text-slate-700 font-medium">Street address</Label>
          <Input
            id="street"
            data-testid="input-street"
            value={data.street_address}
            onChange={(e) => update({ street_address: e.target.value })}
            placeholder="12 Elm Street"
            className="mt-1.5 h-12 bg-white border-slate-200 focus-visible:ring-[#FF7F00]"
          />
        </div>
        <div>
          <Label htmlFor="postcode" className="text-slate-700 font-medium">Postcode</Label>
          <Input
            id="postcode"
            data-testid="input-postcode"
            value={data.postcode}
            onChange={(e) => update({ postcode: e.target.value.toUpperCase() })}
            placeholder="PE1 1AA"
            aria-invalid={postcodeInvalid}
            className={`mt-1.5 h-12 bg-white focus-visible:ring-[#FF7F00] uppercase ${
              postcodeInvalid ? "border-red-400 focus-visible:ring-red-400" : "border-slate-200"
            }`}
          />
          {postcodeInvalid ? (
            <p data-testid="error-postcode" className="mt-1.5 text-xs text-red-600">
              Enter a valid UK postcode (e.g. PE1 1AA).
            </p>
          ) : (
            <p className="mt-1.5 text-xs text-slate-400">UK format only.</p>
          )}
        </div>

        <div>
          <Label className="text-slate-700 font-medium">Property type</Label>
          <div className="mt-2 flex flex-wrap gap-2" data-testid="property-type-chips">
            {PROPERTY_TYPES.map((t) => {
              const active = data.property_type === t;
              return (
                <button
                  key={t}
                  type="button"
                  onClick={() => update({ property_type: t })}
                  data-testid={`property-${t.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
                  className={`px-4 h-10 rounded-full border text-sm font-medium transition-all ${
                    active
                      ? "chip-selected"
                      : "border-slate-200 bg-white text-slate-700 hover:border-[#FFB870] hover:bg-[#FFF7EE]"
                  }`}
                >
                  {t}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
